import type { RouteRecordRaw } from 'vue-router';

// The admin is Users for now, and both staff roles hold `users:list`, so the
// root lands there. Anything that means "home" points at the `Users` route.
export const rootRoute: RouteRecordRaw = {
  path: '/',
  redirect: { name: 'Users' },
};

export const usersRoute: RouteRecordRaw = {
  path: '/users',
  name: 'Users',
  component: () => import('./pages/UsersPage.vue'),
  meta: {
    layout: 'main',
    // Admins browse the directory; creating users and assigning roles is
    // superadmin-only and gated in-component.
    authorize: ({ isGranted }) => isGranted('omb:core:users:list'),
  },
};

export const userDetailRoute: RouteRecordRaw = {
  path: '/users/:id',
  name: 'UserDetail',
  component: () => import('./pages/UserPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('omb:core:users:get'),
  },
};
